import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@SupplyLand/Services/EmailService";

// Modifying the UpdateCart handler chain to add additional paramters to updateCart
// This is being used in the back-end for setting the Residential flag

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type populateParameterProps = Parameters<typeof PopulateApiParameter>[0];

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter>;

export const CustomPopulateParameters: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        formName: state.fieldValues["formName"],
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        message: state.fieldValues["message"],
        topic: state.fieldValues["topic"],
        topicLabel: state.fieldValues["topicLabel"],
        phoneNumber: state.fieldValues["phoneNumber"],
        emailAddress: state.fieldValues["emailAddress"],
        emailTo: props.parameter.emailRecipients,
        textField1: state.fieldValues["textField1"],
        textField1Label: state.fieldValues["textField1Label"],
        textField2: state.fieldValues["textField2"],
        textField2Label: state.fieldValues["textField2Label"],
        textField3: state.fieldValues["textField3"],
        textField3Label: state.fieldValues["textField3Label"],
        textField4: state.fieldValues["textField4"],
        textField4Label: state.fieldValues["textField4Label"],
        textField5: state.fieldValues["textField5"],
        textField5Label: state.fieldValues["textField5Label"],
        textField6: state.fieldValues["textField6"],
        textField6Label: state.fieldValues["textField6Label"],
        textField7: state.fieldValues["textField7"],
        textField7Label: state.fieldValues["textField7Label"],
        textField8: state.fieldValues["textField8"],
        textField8Label: state.fieldValues["textField8Label"],
        textField9: state.fieldValues["textField9"],
        textField9Label: state.fieldValues["textField9Label"],
        textField10: state.fieldValues["textField10"],
        textField10Label: state.fieldValues["textField10Label"],
        textField11: state.fieldValues["textField11"],
        textField11Label: state.fieldValues["textField11Label"],
        textField12: state.fieldValues["textField12"],
        textField12Label: state.fieldValues["textField12Label"],
        textField13: state.fieldValues["textField13"],
        textField13Label: state.fieldValues["textField13Label"],
        textField14: state.fieldValues["textField14"],
        textField14Label: state.fieldValues["textField14Label"],
        textField15: state.fieldValues["textField15"],
        textField15Label: state.fieldValues["textField15Label"],
        numericField1: state.fieldValues["numericField1"],
        numericField1Label: state.fieldValues["numericField1Label"],
        numericField2: state.fieldValues["numericField2"],
        numericField2Label: state.fieldValues["numericField2Label"],
        numericField3: state.fieldValues["numericField3"],
        numericField3Label: state.fieldValues["numericField3Label"],
        numericField4: state.fieldValues["numericField4"],
        numericField4Label: state.fieldValues["numericField4Label"],
        numericField5: state.fieldValues["numericField5"],
        numericField5Label: state.fieldValues["numericField5Label"],
        numericField6: state.fieldValues["numericField6"],
        numericField6Label: state.fieldValues["numericField6Label"],
        numericField7: state.fieldValues["numericField7"],
        numericField7Label: state.fieldValues["numericField7Label"],
        numericField8: state.fieldValues["numericField8"],
        numericField8Label: state.fieldValues["numericField8Label"],
        numericField9: state.fieldValues["numericField9"],
        numericField9Label: state.fieldValues["numericField9Label"],
        numericField10: state.fieldValues["numericField10"],
        numericField10Label: state.fieldValues["numericField10Label"],
    };
};

export const CustomSendDataToApi: HandlerType = async props => {
    await submitContactUsForm(props.apiParameter);
};

replaceInChain(chain, PopulateApiParameter, CustomPopulateParameters);

replaceInChain(chain, SendDataToApi, CustomSendDataToApi);
